import PropTypes from 'prop-types';
import React from 'react';

import stopwords from './stopwords';

import Headline from '../../atoms/headline/headline';
import StyledTypoHeadline from './typoHeadline.style';

const TypoHeadline = ({
  headline,
  headlineId,
  color = 'default',
  highlight = true,
  alignment = 'left',
  ...props
}) => {
  const words = headline.trim().split(' ');

  let headlineArray;

  if (stopwords.includes(words[0].toLowerCase())) {
    headlineArray = [`${words[0]} ${words[1]}`, ...words];
    headlineArray.splice(1, 2);
  } else {
    headlineArray = words;
  }

  return (
    <StyledTypoHeadline color={color} highlight={highlight} alignment={alignment}>
      <Headline teaser className="typoHeadline__headline" id={headlineId}>
        {headlineArray &&
          headlineArray.map((word, index) =>
            index === 0 ? (
              <div className="typoHeadline__first-line" key={word}>
                <span className="typoHeadline__first-word">{word}</span>
              </div>
            ) : (
              <span className="typoHeadline__word" key={word}>
                {word}
              </span>
            )
          )}
      </Headline>
    </StyledTypoHeadline>
  );
};

TypoHeadline.propTypes = {
  headlineId: PropTypes.string,
  headline: PropTypes.string.isRequired,
  color: PropTypes.string,
  highlight: PropTypes.bool,
  alignment: PropTypes.oneOf(['left', 'right', 'center'])
};

export default TypoHeadline;
